import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['shareLink']

  copyOnClick(event) {
    event.preventDefault()
    let copyEl = document.createElement('input')
    copyEl.value = this.shareLinkTarget.getAttribute('data-share-url')
    document.body.appendChild(copyEl)
    copyEl.select()
    //TODO: Replace execCommand with Clipboard API
    document.execCommand('copy')
    document.body.removeChild(copyEl)
  }


}
